"use client";
import WheelModal, { WheelModalProps } from "@/components/ModalPopup/WheelModal";

import dialogManager from "@/dialog/manager";
import useWheelStore from "@/stores/useWheelStore";
import { useEffect, useMemo, useRef, useState } from "react";

const WheelSection = () => {
    const wheelModalRef = useRef<WheelModalProps | null>(null);
    const [data, setData] = useState<any>([]);
    const keyName = useMemo(() => {
        return "WheelSection";
    }, []);
    const { setWheel, status } = useWheelStore((state) => ({
        setWheel: state.setWheel,
        status: state.status,
    }));
    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        dialogManager.registerDialog({
            key: keyName,
            async show() {
                // try {
                //     await getData();
                //     if (status === 3) {
                //         return "close";
                //     }
                // } catch {
                //     return "close";
                // }
                wheelModalRef?.current?.onOpen(data);
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keyName, data, status]);

    const getData = async () => {
        // await setWheel();
        const data = await setWheel();
        if (data && useWheelStore.getState().status === 1) {
            setData(data);
        }
    };

    const destoryComponent = () => {
        dialogManager.hideDialog(keyName); // 隐藏对话框
    };

    return <WheelModal ref={wheelModalRef} onDestory={destoryComponent} />;
};

export default WheelSection;
